export default __webpack_public_path__ + "static/media/add-a-places.740d82d5.svg";